import { FC, useCallback } from "react"
import { useDispatch } from "react-redux"
import { Link } from "gatsby"

// components
import {
  findIcon,
  iconsSizedForCatSideNav
} from "../../components/BrowseByTopicSection/Topic"

// utils
import { setAudience } from "../../store/slices/audience.slice"
import { returnUrlWithLangCodePrefixOnly } from "../../utils/general_utils"

// styles
import {
  sideNavWrapper,
  iconWrapper,
  selected
} from "./GenericSideNav.module.scss"
import { handleUrlString } from "../../utils/seo/seo_utils"

export type PropItem = {
  featuredCategoriesInternalTitle: string
  audienceValue: string
}

export type Props = {
  categories: PropItem[]
  selectedCategory: string
  iconName: string
  prefixedBasePath: string
}

const GenericSideNav: FC<Props> = ({
  categories,
  selectedCategory,
  iconName,
  prefixedBasePath
}) => {
  const dispatch = useDispatch()

  const handleSelect = useCallback(
    (audience: string) => {
      dispatch(setAudience(audience))
    },
    [dispatch]
  )

  return (
    <div className={sideNavWrapper}>
      <ul>
        {categories?.map((cat) => {
          return (
            <li key={cat?.featuredCategoriesInternalTitle}>
              <Link
                onClick={() => handleSelect(cat.audienceValue)}
                to={handleUrlString(`${prefixedBasePath}`, {
                  removePrefix: true
                })}
              >
                {cat?.featuredCategoriesInternalTitle}
              </Link>
            </li>
          )
        })}
        <li className={selected}>
          <div className={iconWrapper}>
            {findIcon(iconName, iconsSizedForCatSideNav)}
          </div>
          <div>{selectedCategory}</div>
        </li>
      </ul>
    </div>
  )
}

export default GenericSideNav
